// extracted by mini-css-extract-plugin
export default {"container":"CreateJobFieldsTab_container__Vqso7"};